export const Logo = ({ size = 44, withText = true, light = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img src="/img/logo.png" alt="RisQZero" width={size} height={size} className="object-contain" style={{ width: size, height: size }} />
    {withText && (
      <div className="leading-none">
        <div className={`font-heading font-extrabold tracking-tight text-[1.45rem] ${light ? "text-white" : "text-forest"}`}>
          Ris<span className="text-african">Q</span>Zer<span className="relative inline-block">o<span className="absolute left-[55%] top-[12%] h-[82%] w-[2px] rotate-[28deg] bg-african rounded-full" /></span>
        </div>
        <div className={`font-accent text-[0.68rem] tracking-[0.18em] mt-1 ${light ? "text-white/70" : "text-forest/70"}`}>de la Qualité à Zéro accident</div>
      </div>
    )}
  </div>
);
